import * as actionTypes from "./../../Constants/categoryActionTypes";
import API from "./../../Constants/categories/API"
import * as categoryServices from "../../services/categories/index"

export const addNewCategory = (categoryData, allCategories) => ({
    type: actionTypes.ADD_CAT,
    payload: { categoryData: allCategories.concat(categoryData) }
})

// cat-> current categories , addedCat => newly added cat
export function addCategory (cat, addedCat) {
    return async dispatch => {
        const request = await categoryServices.req.addCategory(API.addCategory, addedCat)
        //return dispatch(newCategories(cat));
        return dispatch(addNewCategory(request, cat));
    };
}